import { Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { errorToast, successToast } from '../../../helpers';
import MainContainer from '../../../layout/MainContainer';
import AddNewRole from '../../../Modals/addNewRole';
import { ConfirmationModal } from '../../../Modals/confirmationModal';
import EditNewRole from '../../../Modals/editRole';
import {
  useAddRoleMutation,
  useLazyDeleteRoleQuery,
  useLazyGetAllRolesQuery,
  useLazyRoleDetailQuery,
  useUpdateRoleMutation,
} from '../../../service/user&Roles';
import { CommonBody, DataType, RoleTypes } from '../../../types/General';
import { generateEncryptedKeyBody } from '../../../utils/crypto';
let flag: boolean = false;

const Roles = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [selectedId, setSelectedId] = useState(0);
  const [openWarnModal, setOpenWarnModal] = useState(false);

  const [getRoles] = useLazyGetAllRolesQuery();
  const [addRole] = useAddRoleMutation();
  const [updateRole] = useUpdateRoleMutation();
  const [roleDetail] = useLazyRoleDetailQuery();
  const [deleteRole] = useLazyDeleteRoleQuery();

  const [selectedRoleId, setSelectedRoleId] = useState<string>('');
  const [roleName, setRoleName] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [roles, setRoles] = useState<RoleTypes[]>([]);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const totalPages = Math.ceil(totalCount / 10);

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const [permissions, setPermissions] = useState<DataType[]>([
    {
      sideBarId: 1,
      label: 'Dashboard',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 2,
      label: 'Registrations',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 3,
      label: 'Listing',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 4,
      label: 'Vechile Types',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 5,
      label: 'Vehile Specifications',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 6,
      label: 'Blogs',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 7,
      label: 'Inspection Requests',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 8,
      label: 'Manage Packages',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 9,
      label: 'Manage Promo Codes',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 10,
      label: 'Promotional Campaigns',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 11,
      label: 'Ratings & Reviews',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    // {
    //   sideBarId: 12,
    //   label: "Manage Sub-admin",
    //   isAdd: false,
    //   isView: false,
    //   isEdit: false,
    //   isDelete: false,
    // },

    {
      sideBarId: 13,
      label: 'Manage Notifications',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 14,
      label: 'Manage CMS',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 15,
      label: 'Manage Payment',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
    {
      sideBarId: 16,
      label: 'Analytics',
      isAdd: false,
      isView: false,
      isEdit: false,
      isDelete: false,
    },
  ]);

  //get DATA
  const fetchRoles = async () => {
    setLoading(true);
    try {
      const response = await getRoles({}).unwrap();
      setLoading(false);
      if (response?.statusCode === 200) {
        setRoles(response?.data?.SubAdminAccess || []);
      } else {
        setRoles([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || '');
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    const isAnyPermissionSelected = permissions?.some(
      (permission) =>
        permission.isView || permission.isAdd || permission.isEdit || permission.isDelete
    );
    if (roleName === '') return;

    if (!isAnyPermissionSelected) {
      errorToast('Please assign atleast one permission');
      return;
    }
    const body = {
      name: roleName,
      permission: permissions?.map((data) => ({
        sideBarId: data?.sideBarId,
        label: data?.label,
        isAdd: data?.isAdd,
        isView: data?.isView,
        isEdit: data?.isAdd,
        isDelete: data?.isDelete,
      })),
    };

    try {
      setLoading(true);
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response: any = selectedData?.id
        ? await updateRole({
            body: encryptedBody,
            id: selectedData?.id,
          }).unwrap()
        : await addRole(encryptedBody).unwrap();

      if (response?.statusCode === 200) {
        setLoading(false);
        if (selectedRoleId) {
          successToast('Role updated successfully');
        } else {
          successToast('Role added successfully');
        }
        setRoleName('');
        // setPermissions([]);
        setOpenModal(false);
        fetchRoles();
      } else {
        setLoading(false);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || '');
      console.error(error);
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await deleteRole({ id: selectedRoleId }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        successToast('Role deleted successfully');
      } else {
        setRoles([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || '');
    } finally {
      setLoading(false);
      fetchRoles();
    }
  };
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [openModal2, setOpenModal2] = useState(false);
  const handleCloseModal2 = () => {
    setOpenModal2(false);
  };

  // useEffect(() => {

  //   if (selectedRoleId && flag) {
  //     fetchRoleDetails(selectedRoleId);
  //   }
  // }, [selectedRoleId, openModal]);

  useEffect(() => {
    fetchRoles();
  }, []);
  const [selectedData, setSelectedData] = useState({ id: '' });
  return (
    <>
      <MainContainer>
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Roles</h1>
            <p>
              <span onClick={() => navigate('/dashboard')}>Dashboard</span> - User Management -
              Roles
            </p>
          </div>
          <div className="right_s">
            <Button
              className="btn btn_secondary"
              onClick={() => {
                setSelectedData({ id: '' });
                setOpenModal(true);
              }}
            >
              Create Roles
            </Button>
          </div>
        </div>

        <div className="roles_list gap_m">
          {roles.map((role, i) => (
            <div className="cards" key={i}>
              <h2>{role?.name}</h2>
              {/* <p>Total users with this role: 5</p> */}
              <ul>
                {role?.permission
                  ?.filter((itx) => itx.isAdd || itx.isDelete || itx.isEdit || itx.isView)
                  .map((permm: any, i) => <li key={i}>{permm?.label}</li>)}
              </ul>

              <div className="btn_flex">
                <Button
                  className="btn btn_highlight"
                  onClick={() => {
                    flag = false;

                    setSelectedRoleId(String(role?._id));
                    // fetchRoles();
                    setOpenWarnModal(true);
                  }}
                >
                  Delete Role
                </Button>
                <Button
                  className="btn btn_highlight"
                  onClick={() => {
                    setPermissions(role?.permission);
                    setRoleName(role?.name);
                    setSelectedData({ id: role?._id as string });
                    setOpenModal2(true);
                  }}
                >
                  Edit Role
                </Button>
              </div>
            </div>
          ))}
        </div>
      </MainContainer>

      <AddNewRole
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        permissions={permissions}
        setPermissions={setPermissions}
        setRoleName={setRoleName}
        roleName={roleName}
        handleSubmit={handleSubmit}
      />
      <EditNewRole
        open={openModal2}
        onClose={handleCloseModal2}
        setOpen={setOpenModal2}
        permissions={permissions?.map((data) => ({
          sideBarId: data?.sideBarId,
          label: data?.label,
          isAdd: data?.isAdd,
          isView: data?.isView,
          isEdit: data?.isEdit,
          isDelete: data?.isDelete,
        }))}
        setPermissions={setPermissions}
        setRoleName={setRoleName}
        roleName={roleName}
        handleSubmit={handleSubmit}
      />
      <ConfirmationModal
        text={'Are you sure to delete this role?'}
        openModal={openWarnModal}
        setOpenModal={setOpenWarnModal}
        handleSubmit={handleDelete}
      />
    </>
  );
};

export default Roles;
